module.exports = __webpack_public_path__ + "static/img/phone_logo.6b47b3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build901/components/common/img/phone_logo.png
// module id = Biv8
// module chunks = 47